import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'circle-letter-n', 'CircleLetterN', [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"}],["path",{"d":"M10 16v-8l4 8v-8"}]]);